var map = {
	"./de/metadata.json": 3226,
	"./en/metadata.json": 6622,
	"./es/metadata.json": 2053,
	"./fr/metadata.json": 8189,
	"./it/metadata.json": 4729,
	"./nl/metadata.json": 7155,
	"./pt/metadata.json": 235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6054;